"use client";

import { useEffect } from "react";
import Image from "next/image";
import datadog from "@ilg-core/analytics/datadog";
import styles from "@/components/ErrorBoundary/ErrorBoundary.module.css";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    datadog.log.error("Error Page", {
      statusMessage: error.message,
      stack: error.stack,
    });
  }, [error]);

  return (
    <div data-testid="error-page" className={styles.errorPage}>
      <Image
        src={"/assets/images/info-triangle.svg"}
        alt={"error"}
        width={64}
        height={64}
      />
      <div className={styles.title}>Something went wrong</div>
      <div className={styles.message}>
        <p className={styles.messageText}>
          It looks like there&apos;s a glitch in the system. Just refresh to
          get things up and running again.
        </p>
      </div>
      <button className={styles.retryButton} onClick={reset}>
        Try again
      </button>
    </div>
  );
}
